import React, { Fragment, useState } from "react";
import { Button, Nav } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import { useNavigate, useLocation } from "react-router-dom";
import { Navigation } from "react-minimal-side-navigation";
import Worksheets from "./worksheets";
import Fitters from "./fitters";
import Users from "./users";
import UploadPaperwork from "./uploadPaperwork";
import UnsubmittedWorksheetsReport from "./unsubmittedWorksheetsReport";
import AllWorksheetsReport from "./allWorksheetsReport";
import MaterialManufacturerReport from "./materialManufacturerReport";
import PaymentCardRequiredReport from "./paymentCardRequiredReport";
import PrintFinanceReport from "./printFinance";
import RejectByAccountsReport from "./rejectByAccountsReport";
import FitterSignInReport from "./fitterSignInReport";
import MeasureRevisits from "./measureRevisits";
import QueryInstalls from "./queryInstalls";
import Pendingwages from "./pendingWages";
import CompleteWages from "./completeWages";
import EcoJobs from "./ecoJobs";
import PendingInvoices from "./pendingInvoices";
import RejectedInvoices from "./rejectedInvoices";
import ProcessedPayApps from "./processedPayApps";
import InvoicedPayApps from "./invoicedPayApps";
import SagePayappExport from "./sagePayappExport";

import "./../assets/styles/dashboard.css";
import "react-minimal-side-navigation/lib/ReactMinimalSideNavigation.css";


const Dashboard = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const { data } = location.state !== null ? location.state : "";
    const isAdmin = (data !== undefined && data !== null) ? (((data.data.userDetails.depot).toLowerCase()).includes("none") ? true : false) : false;

    const [showWorksheets, setShowWorksheets] = useState(true);
    const [showFitters, setShowFitters] = useState(false);
    const [showUsers, setShowUsers] = useState(false);
    const [showMeasureRevisits, setShowMeasureRevisits] = useState(false);
    const [showQueryInstalls, setShowQueryInstalls] = useState(false);
    const [showUnsubmittedWorksheets, setShowUnsubmittedWorksheets] = useState(false);
    const [showWorksheetDownloader, setShowWorksheetDownloader] = useState(false);
    const [showMaterialManufacturer, setShowMaterialManufacturer] = useState(false);
    const [showPaymentCardRequired, setShowPaymentCardRequired] = useState(false);
    const [showFitterSignInReport, setShowFitterSignInReport] = useState(false);
    const [showPrintFinance, setShowPrintFinance] = useState(false);
    const [showPendingWages, setShowPendingWages] = useState(false);
    const [showCompleteWages, setShowCompleteWages] = useState(false);
    const [showEcoJobs, setShowEcoJobs] = useState(false);
    const [showPendingInvoices, setShowPendingInvoices] = useState(false);
    const [showRejectedInvoices, setShowRejectedInvoices] = useState(false);
    const [showProcessedPayAPpps, setShowProcessedPayAPpps] = useState(false);
    const [showInvoicedPayAPpps, setShowInvoicedPayAPpps] = useState(false);
    const [showSagePayappExport, setShowSagePayappExport] = useState(false);
    const [showRejectByAccounts, setShowRejectByAccounts] = useState(false);
    const [showUploadPaperwork, setShowUploadPaperwork] = useState(false);

    const userSideMenuItems = [
        {
            title: "Worksheets",
            itemId: "/worksheets",
        },
        {
            title: "Upload Paperwork",
            itemId: "/uploadPaperwork",
        },
        {
            title: "Fitters",
            itemId: "/fitters",
        },
        {
            title: "Measure Revisits",
            itemId: "/measureRevisits",
        },
        {
            title: "Query Installs",
            itemId: "/queryInstalls",
        },
        {
            title: "Reports", itemId: "/reports",
            subNav: [
                { title: "Unsubmitted Worksheets", itemId: "/reports/unsubmittedWorksheets" },
                { title: "Worksheet Downloader", itemId: "/reports/allWorksheetsReport" },
                { title: "Material Manufacturer CSV", itemId: "/reports/materialManufacturerReport" },
                { title: "Payment Cards Required", itemId: "/reports/paymentCardRequiredReport" },
                { title: "Rejected By Accounts", itemId: "/reports/rejectByAccountsReport" },
                { title: "Fitter SignIn Report", itemId: "/reports/fitterSignInReport" }
            ]
        },
        {
            title: "Wages", itemId: "/wages",
            subNav: [
                { title: "Pending Wages", itemId: "/wages/pendingWages" },
                { title: "Complete Wages", itemId: "/wages/completeWages" }
            ]
        },
        {
            title: "Invoicing Work", itemId: "/invoicing",
            subNav: [
                { title: "Rejected by Accounts", itemId: "/invoicing/rejectedInvoices" }
            ]
        },
        {
            title: "Eco Jobs",
            itemId: "/ecoJobs",
        },
    ]

    const adminSideMenuItems = [
        {
            title: "Worksheets",
            itemId: "/worksheets",
        },
        {
            title: "Upload Paperwork",
            itemId: "/uploadPaperwork",
        },
        {
            title: "Fitters",
            itemId: "/fitters",
        },
        {
            title: "Measure Revisits",
            itemId: "/measureRevisits",
        },
        {
            title: "Query Installs",
            itemId: "/queryInstalls",
        },
        {
            title: "Users",
            itemId: "/users"
        },
        {
            title: "Reports", itemId: "/reports",
            subNav: [
                { title: "Unsubmitted Worksheets", itemId: "/reports/unsubmittedWorksheets" },
                { title: "Worksheet Downloader", itemId: "/reports/allWorksheetsReport" },
                { title: "Material Manufacturer CSV", itemId: "/reports/materialManufacturerReport" },
                { title: "Payment Cards Required", itemId: "/reports/paymentCardRequiredReport" },
                { title: "Print Finance", itemId: "/reports/printFinance" },
                { title: "Rejected By Accounts", itemId: "/reports/rejectByAccountsReport" },
                { title: "Fitter SignIn Report", itemId: "/reports/fitterSignInReport" }
            ]
        },
        {
            title: "Wages", itemId: "/wages",
            subNav: [
                { title: "Pending Wages", itemId: "/wages/pendingWages" },
                { title: "Complete Wages", itemId: "/wages/completeWages" }
            ]
        },
        {
            title: "Invoicing Work", itemId: "/invoicing",
            subNav: [
                { title: "Pending Accounts Review", itemId: "/invoicing/pendingInvoices" },
                { title: "Rejected by Accounts", itemId: "/invoicing/rejectedInvoices" },
                { title: "Processed Pay Apps", itemId: "/invoicing/processedPayApps" },
                { title: "Invoiced Pay Apps", itemId: "/invoicing/invoicedPayApps" },
                { title: "Sage Payapp Export", itemId: "/invoicing/sagePayappExport" }
            ]
        },
        {
            title: "Eco Jobs",
            itemId: "/ecoJobs",
        }
    ]

    const handleLogout = () => {
        navigate("/login");
    }

    const handleSideMenuCkick = (e) => {
        if (e.itemId !== "/reports" && e.itemId !== "/wages" && e.itemId !== "/invoicing") {
            setShowWorksheets(e.itemId === "/worksheets");
            setShowUploadPaperwork(e.itemId === "/uploadPaperwork");
            setShowFitters(e.itemId === "/fitters");
            setShowMeasureRevisits(e.itemId === "/measureRevisits");
            setShowQueryInstalls(e.itemId === "/queryInstalls");
            setShowUsers(e.itemId === "/users");
            setShowUnsubmittedWorksheets(e.itemId === "/reports/unsubmittedWorksheets");
            setShowWorksheetDownloader(e.itemId === "/reports/allWorksheetsReport");
            setShowMaterialManufacturer(e.itemId === "/reports/materialManufacturerReport");
            setShowPaymentCardRequired(e.itemId === "/reports/paymentCardRequiredReport");
            setShowPrintFinance(e.itemId === "/reports/printFinance");
            setShowRejectByAccounts(e.itemId === "/reports/rejectByAccountsReport");
            setShowFitterSignInReport(e.itemId === "/reports/fitterSignInReport");
            setShowPendingWages(e.itemId === "/wages/pendingWages");
            setShowCompleteWages(e.itemId === "/wages/completeWages");
            setShowEcoJobs(e.itemId === "/ecoJobs");
            setShowPendingInvoices(e.itemId === "/invoicing/pendingInvoices");
            setShowRejectedInvoices(e.itemId === "/invoicing/rejectedInvoices");
            setShowProcessedPayAPpps(e.itemId === "/invoicing/processedPayApps");
            setShowInvoicedPayAPpps(e.itemId === "/invoicing/invoicedPayApps");
            setShowSagePayappExport(e.itemId === "/invoicing/sagePayappExport");
        }
    }

    return (
        <Fragment>
            <div>
                <Navbar bg="dark" expand="lg" className="navbar-dark pad-0">
                    <div className="header-logo"></div>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto">
                            <Nav.Link>
                                <Button className="btn-warning" onClick={handleLogout}>Logout</Button>
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </div>

            <div className="side-menu-block">
                <Navigation activeItemId="/worksheets" onSelect={handleSideMenuCkick} items={isAdmin ? adminSideMenuItems : userSideMenuItems} />

                <div className="width-82">
                    {showWorksheets && <Worksheets data={data} />}
                    {showUploadPaperwork && <UploadPaperwork data={data} />}
                    {showFitters && <Fitters data={data} />}
                    {showMeasureRevisits && <MeasureRevisits data={data} />}
                    {showQueryInstalls && <QueryInstalls data={data} />}
                    {showUsers && <Users data={data} />}
                    {showUnsubmittedWorksheets && <UnsubmittedWorksheetsReport data={data} />}
                    {showWorksheetDownloader && <AllWorksheetsReport data={data} />}
                    {showMaterialManufacturer && <MaterialManufacturerReport data={data} />}
                    {showPaymentCardRequired && <PaymentCardRequiredReport data={data} />}
                    {showFitterSignInReport && <FitterSignInReport data={data} />}
                    {showPrintFinance && <PrintFinanceReport data={data} />}
                    {showRejectByAccounts && <RejectByAccountsReport data={data} />}
                    {showPendingWages && <Pendingwages data={data} />}
                    {showCompleteWages && <CompleteWages data={data} />}
                    {showEcoJobs && <EcoJobs data={data} />}
                    {showPendingInvoices && <PendingInvoices data={data} />}
                    {showRejectedInvoices && <RejectedInvoices data={data} />}
                    {showProcessedPayAPpps && <ProcessedPayApps data={data} />}
                    {showInvoicedPayAPpps && <InvoicedPayApps data={data} />}
                    {showSagePayappExport && <SagePayappExport data={data} />}
                </div>
            </div>
        </Fragment>
    )
}

export default Dashboard;